import { Button } from '../../../components/Form/Button';
import { Interpolated } from '../../../components/Interpolated';
import { useTranslation } from '../../../i18n/i18n';
import { Link } from 'react-router-dom';
import './CheckoutFooter.css';

type CheckoutFooterProps = { disabled: boolean; submit: () => void };
export const CheckoutFooter = ({ disabled, submit }: CheckoutFooterProps): JSX.Element => {
	const t = useTranslation().checkout;
	const urls = useTranslation().routes;
	return (
		<div className="checkout-footer">
			<p className="policy">
				<Interpolated
					template={t.acceptTerms}
					data={{
						purchaseTerms: <Link to={urls.purchaseTerms}>{t.purchaseTerms}</Link>,
						privacyPolicy: <Link to={urls.privacyPolicy}>{t.privacyPolicy}</Link>,
					}}
				/>
			</p>
			<Button disabled={disabled} onClick={() => submit()}>
				{t.placeOrder}
			</Button>
		</div>
	);
};
